import { API_ENDPOINTS } from "@/api/services/helpdesk/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const helpDeskSpocApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchMenuSubmenu: builder.query({
      query: (menuId) => ({
        url: API_ENDPOINTS.HELPDESKSPOC.FETCH_MENU_SUBMENU_OPTIONS(menuId),
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: [{ type: "helpDeskSpocApi", id: "LIST" }],
    }),
    addHelpDeskSopc: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.HELPDESKSPOC.ADD_HELPDESK_SPOC,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "helpDeskSpocApi", id: "LIST" }],
    }),
    statusUpdateHelpDeskSopc: builder.mutation({
      query: (id) => ({
        url: API_ENDPOINTS.HELPDESKSPOC.UPDATE_STATUS_SPOC(id),
        method: "PUT",
        // body: formData,
      }),
      invalidatesTags: [{ type: "helpDeskSpocApi", id: "LIST" }],
    }),
    updateHelpDeskSopc: builder.mutation({
      query: ({ formData, id }) => ({
        url: API_ENDPOINTS.HELPDESKSPOC.UPDATE_SPOC(id),
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: [{ type: "helpDeskSpocApi", id: "LIST" }],
    }),
    deleteHelpDeskSopc: builder.mutation({
      query: (id) => ({
        url: API_ENDPOINTS.HELPDESKSPOC.DELETE_SPOC(id),
        method: "DELETE",
        // body: formData,
      }),
      invalidatesTags: [{ type: "helpDeskSpocApi", id: "LIST" }],
    }),
    fetchHelpDeskSpoc: builder.query({
      query: () => ({
        url: API_ENDPOINTS.HELPDESKSPOC.FETCH_SPOC_LIST,
        method: "GET",
      }),
      transformResponse: (response) => response?.data,
      providesTags: () => [{ type: "helpDeskSpocApi", id: "LIST" }],
    }),
  }),
});

export const {
  useFetchMenuSubmenuQuery,
  useAddHelpDeskSopcMutation,
  useFetchHelpDeskSpocQuery,
  useStatusUpdateHelpDeskSopcMutation,
  useDeleteHelpDeskSopcMutation,
  useUpdateHelpDeskSopcMutation,
} = helpDeskSpocApi;
